<template>
  <div>
    <div class="main-title">
      车辆租赁账单记录
      <el-button-group>
        <el-button
          icon="el-icon-download"
          size="small"
          @click="excel"
          :loading="exporting"
        ></el-button>
        <el-button
          icon="el-icon-printer"
          size="small"
          @click="print"
        ></el-button>
        <el-button
          icon="el-icon-refresh"
          size="small"
          @click="refresh"
          :loading="loading"
        ></el-button>
      </el-button-group>
    </div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-select
              v-model="searchForm.company_ids"
              multiple
              placeholder="选择科目"
              @change="search(searchParams)"
              style="width: 250px"
            >
              <el-option
                v-for="item in companyList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="searchForm.daterange"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :disabled="user.buttons.indexOf(1020) < 0"
              :picker-options="datePickerOptions"
              @change="search(searchParams)"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索单据编号"
              v-model="searchForm.query"
              prefix-icon="el-icon-search"
              clearable
              @input="inputSearch(searchParams)"
              style="width: 130px"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.fee_package_id"
              filterable
              placeholder="计费方式"
              style="width: 140px"
              @change="search(searchParams)"
            >
              <el-option label="全部计费方式" :value="-1"></el-option>
              <el-option label="计时收费" value="0"></el-option>
              <el-option
                v-for="item in feePackageList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索教练"
              v-model="searchForm.coach_name"
              prefix-icon="el-icon-search"
              clearable
              @input="inputSearch(searchParams)"
              style="width: 130px"
            >
            </el-input>
          </el-form-item>
          <el-form-item v-if="[1, 10].indexOf(user.group_id) >= 0">
            <el-input
              placeholder="搜索业务员"
              v-model="searchForm.sales_name"
              prefix-icon="el-icon-search"
              clearable
              @input="inputSearch(searchParams)"
              style="width: 130px"
            >
            </el-input>
          </el-form-item>
          <el-form-item v-if="user.group_id === 2">
            <el-select
              v-model="searchForm.coach_area"
              placeholder="所属区域"
              style="width: 140px"
              @change="search(searchParams)"
            >
              <el-option label="所属区域" :value="null"></el-option>
              <el-option label="武昌" value="武昌"></el-option>
              <el-option label="汉口" value="汉口"></el-option>
              <el-option label="汉阳" value="汉阳"></el-option>
              <el-option label="未知" value="null"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索备注"
              v-model="searchForm.remark"
              prefix-icon="el-icon-search"
              clearable
              @input="inputSearch(searchParams)"
              style="width: 130px"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <el-table
        ref="table"
        :data="list"
        stripe
        border
        :height="tableHeight"
        :summary-method="getSummaries"
        show-summary
        style="width: 100%"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection"> </el-table-column>
        <el-table-column prop="company_name" label="所属科目" width="100">
        </el-table-column>
        <el-table-column prop="bill_no" label="单据编号" width="90">
        </el-table-column>
        <el-table-column label="打印" width="60">
          <template slot-scope="scope">
            <el-button
              v-if="
                scope.row.pay_status === '已支付' && scope.row.status === '正常'
              "
              type="text"
              @click="printBill(scope.row)"
              >打印</el-button
            >
          </template>
        </el-table-column>
        <el-table-column label="地图轨迹" width="80">
          <template slot-scope="scope">
            <el-button type="text" @click="showTrack(scope.row.id)"
              >地图轨迹</el-button
            >
          </template>
        </el-table-column>
        <el-table-column prop="car_alias" label="车辆编号" width="90">
        </el-table-column>
        <el-table-column prop="licnum" label="车牌号" width="100">
        </el-table-column>
        <el-table-column
          prop="status"
          label="单据状态"
          width="90"
          :filters="statusFilters"
          :filter-method="filterStatus"
          filter-placement="bottom-end"
        >
        </el-table-column>
        <el-table-column
          prop="pay_status"
          label="支付状态"
          width="90"
          :filters="payStatusFilters"
          :filter-method="filterPayStatus"
          filter-placement="bottom-end"
        >
          <template slot-scope="scope">
            <span
              :class="[
                scope.row.pay_status === '已支付' ? 'row-green' : 'row-red',
              ]"
              >{{ scope.row.pay_status }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="secu_name" label="安全员" width="80">
        </el-table-column>
        <el-table-column prop="school_name" label="驾校" width="110">
        </el-table-column>
        <el-table-column prop="coach_name" label="教练" width="80">
        </el-table-column>
        <el-table-column
          prop="coach_phone"
          label="手机号"
          width="110"
          v-if="user.group_id === 2"
        >
        </el-table-column>
        <el-table-column
          prop="coach_area"
          label="区域"
          width="70"
          v-if="user.group_id === 2"
        >
        </el-table-column>
        <el-table-column label="学员" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="showStudent(scope.row)"
              >{{ scope.row.student_count }}个学员</el-button
            >
          </template>
        </el-table-column>
        <el-table-column prop="start_time" label="开始时间" width="160">
        </el-table-column>
        <el-table-column prop="end_time" label="结束时间" width="160">
        </el-table-column>
        <el-table-column prop="use_time" label="时长" width="80">
        </el-table-column>
        <el-table-column prop="price_type" label="计费方式" width="110">
        </el-table-column>
        <el-table-column prop="price" label="单价" width="80">
        </el-table-column>
        <el-table-column prop="fee" label="应收金额" width="80">
        </el-table-column>
        <el-table-column prop="fee_discount" label="优惠" width="70">
        </el-table-column>
        <el-table-column prop="discount_rate" label="折扣率" width="80">
        </el-table-column>
        <el-table-column prop="pay_total" label="实收合计" width="80">
        </el-table-column>
        <el-table-column prop="pay_cash" label="现金" width="80">
        </el-table-column>
        <el-table-column prop="pay_alipay" label="支付宝" width="80">
        </el-table-column>
        <el-table-column prop="pay_wechat" label="微信支付" width="80">
        </el-table-column>
        <el-table-column prop="pay_pos" label="银行卡" width="80">
        </el-table-column>
        <el-table-column prop="pay_balance" label="充值卡" width="80">
        </el-table-column>
        <el-table-column prop="pay_coupon" label="代金券" width="80">
        </el-table-column>
        <el-table-column
          prop="pay_virtual"
          label="挂账"
          width="80"
          v-if="user.pay_virtual == '1'"
        >
        </el-table-column>
        <el-table-column
          prop="pay_advance"
          label="预收"
          width="80"
          v-if="user.pay_advance == '1'"
        >
        </el-table-column>
        <el-table-column prop="route_name" label="训练路线" width="80">
        </el-table-column>
        <el-table-column
          prop="exam_service"
          label="培训服务"
          width="80"
          v-if="user.group_id == 1"
        >
        </el-table-column>
        <el-table-column
          prop="exam_service"
          label="类型"
          width="80"
          v-if="user.group_id == 32"
        >
        </el-table-column>
        <el-table-column
          prop="sales_name"
          label="业务员"
          width="70"
          v-if="[1, 10].indexOf(user.group_id) >= 0"
        >
        </el-table-column>
        <el-table-column prop="oper_name" label="操作员" width="70">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          width="300"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="260">
          <template slot-scope="scope">
            <el-button
              v-if="
                scope.row.status === '正常' && scope.row.pay_status === '未支付'
              "
              type="text"
              @click="pay(scope.row.id)"
              >结算</el-button
            >
            <el-button v-else type="text" @click="detail(scope.row.id)"
              >详情</el-button
            >
            <el-button type="text" @click="editInfo(scope.row)"
              >修改信息</el-button
            >
            <el-button
              v-if="
                scope.row.status === '正常' && scope.row.pay_status === '已支付'
              "
              type="text"
              @click="rePay(scope.row)"
              >重新结算</el-button
            >
            <el-button
              v-if="scope.row.status === '正常'"
              type="text"
              @click="invalid(scope.row)"
              >作废</el-button
            >
            <el-button v-else type="text" @click="valid(scope.row)"
              >恢复</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="currentPage"
        :page-sizes="[minPageSize, 50, 100, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 学员信息窗口 -->
    <el-dialog title="学员信息" :visible.sync="studentDialogVisible">
      <div v-if="studentLoading" style="height: 100px; text-align: center">
        正在加载学员信息...
      </div>
      <el-table v-if="!studentLoading" :data="studentList">
        <el-table-column prop="name" label="姓名"></el-table-column>
        <el-table-column prop="idcard" label="身份证号"></el-table-column>
        <el-table-column label="操作" v-if="selectRow.pay_status == '未支付'">
          <template slot-scope="scope">
            <el-button
              type="text"
              style="color: #f56c6c"
              @click="delStudent(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-alert
        v-if="!studentLoading && selectRow.pay_status == '已支付'"
        title="提示:已结算的单据不能再增加或删除学员"
        type="info"
        style="margin-top: 10px"
        :closable="false"
      >
      </el-alert>
      <el-form
        :model="studentForm"
        ref="studentForm"
        :rules="studentFormRules"
        label-width="120px"
        v-if="!studentLoading && selectRow.pay_status == '未支付'"
        style="margin-top: 50px"
      >
        <el-form-item label="姓名" prop="name">
          <el-input v-model="studentForm.name"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="idcard">
          <el-input v-model="studentForm.idcard"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addStudent" :loading="studentAdding"
            >添加学员</el-button
          >
          <el-button @click="readIdcard" :loading="studentAdding"
            >读身份证</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 修改表单 -->
    <el-dialog :title="editFormTitle" :visible.sync="editFormVisible">
      <el-form
        :model="editForm"
        ref="editForm"
        :rules="editFormRules"
        label-width="200px"
      >
        <el-form-item label="安全员" prop="secu_id">
          <el-select
            v-model="editForm.secu_id"
            filterable
            remote
            reserve-keyword
            placeholder="输入安全员姓名或拼音"
            :remote-method="searchSecu"
            :loading="secuLoading"
          >
            <el-option
              v-for="item in secuList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用车人 / 教练" prop="coach_id">
          <el-select
            v-model="editForm.coach_id"
            filterable
            remote
            reserve-keyword
            placeholder="输入教练姓名或拼音"
            :remote-method="searchCoach"
            :loading="coachLoading"
          >
            <el-option
              v-for="item in coachList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="训练路线">
          <el-select v-model="editForm.route_name">
            <el-option label="路线1" value="路线1"></el-option>
            <el-option label="路线2" value="路线2"></el-option>
            <el-option label="路线3" value="路线3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="计费方式" v-if="editForm.fee_package_id > 0">
          <el-select v-model="editForm.fee_package_id">
            <el-option
              v-for="item in feePackageListEditFilter"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="培训服务" v-if="user.group_id == 1">
          <el-select v-model="editForm.exam_service">
            <el-option
              v-for="item in examServiceList"
              :key="item.value"
              :label="item.value"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型" v-if="user.group_id == 32">
          <el-select v-model="editForm.exam_service">
            <el-option
              v-for="item in examServiceList"
              :key="item.value"
              :label="item.value"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="业务员" v-if="[1, 10].indexOf(user.group_id) >= 0">
          <el-select
            v-model="editForm.sales_id"
            filterable
            remote
            reserve-keyword
            placeholder="输入业务员姓名或拼音"
            :remote-method="searchSales"
            :loading="salesLoading"
          >
            <el-option
              v-for="item in salesList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="editForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editCommit" :loading="editCommiting"
          >确 定</el-button
        >
        <el-button @click="editFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 结算窗口 -->
    <pay-dialog
      :visible="payDialogVisible"
      :user="user"
      :bill-id="billId"
      @confirm="payConfirm"
      @cancel="payCancel"
    ></pay-dialog>
    <!-- 账单详情窗口 -->
    <bill-dialog
      :visible="billDialogVisible"
      :bill-id="billId"
      @close="billDialogVisible = false"
    ></bill-dialog>
    <!-- 轨迹 -->
    <track-dialog
      :visible="trackDialogVisible"
      :gpsdata="trackDialogGpsData"
      @close="trackDialogVisible = false"
    ></track-dialog>
  </div>
</template>

<script>
import PayDialog from "./PayDialog";
import BillDialog from "./BillDialog";
import TrackDialog from "./TrackDialog";
import ListFunc from "../../mixins/ListFunc";
import DatePickerOptions from "../../mixins/DatePickerOptions";
import moment from "moment";
import offset from "../../assets/offset";
export default {
  mixins: [ListFunc, DatePickerOptions],
  props: {
    user: Object,
  },
  components: {
    PayDialog,
    BillDialog,
    TrackDialog,
  },
  data() {
    return {
      sqlcode: "bill_list",
      companyList: [],
      searchForm: {
        company_ids: [],
        query: "",
        daterange: [
          // new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 30),
          this.user.buttons.indexOf(1020) < 0
            ? new Date()
            : new Date().setTime(new Date().getTime() - 3600 * 1000 * 24),
          new Date(),
        ],
        fee_package_id: -1,
        coach_name: "",
        sales_name: "",
        coach_area: null,
        remark: "",
      },
      statusFilters: [
        { text: "正常", value: "正常" },
        { text: "作废", value: "作废" },
      ],
      payStatusFilters: [
        { text: "已支付", value: "已支付" },
        { text: "未支付", value: "未支付" },
      ],
      studentDialogVisible: false,
      studentList: [],
      studentLoading: false,
      studentAdding: false,
      studentForm: {
        bill_id: 0,
        company_id: 0,
        name: "",
        idcard: "",
      },
      studentFormRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        idcard: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
        ],
      },
      secuList: [],
      secuLoading: false,
      coachList: [],
      coachLoading: false,
      salesList: [],
      salesLoading: false,
      editFormVisible: false,
      editFormTitle: "修改单据信息",
      editForm: {
        id: 0,
        company_id: 0,
        coach_id: null,
        secu_id: null,
        sales_id: null,
        route_name: "路线1",
        exam_service: null,
        fee_package_id: 0,
        remark: "",
      },
      editFormRules: {
        coach_id: [{ required: true, message: "请选择教练", trigger: "blur" }],
        secu_id: [{ required: true, message: "请选择安全员", trigger: "blur" }],
        min_fee: [
          { required: true, message: "无保底消费请填0", trigger: "blur" },
        ],
        yajing: [{ required: true, message: "无押金请填0", trigger: "blur" }],
      },
      editCommiting: false,
      payDialogVisible: false,
      billId: 0,
      sumProps: [
        "use_time",
        "fee",
        "fee_discount",
        "pay_total",
        "pay_cash",
        "pay_alipay",
        "pay_wechat",
        "pay_pos",
        "pay_balance",
        "pay_coupon",
        "pay_virtual",
        "pay_advance",
      ],
      billDialogVisible: false,
      selectRow: {},
      trackDialogGpsData: [],
      trackDialogVisible: false,
      feePackageList: [],
      feePackageListEditFilter: [],
      examServiceList: [],
    };
  },
  computed: {
    searchParams() {
      if (
        !this.searchForm.daterange ||
        this.searchForm.daterange.length === 0
      ) {
        return {
          company_ids: this.searchForm.company_ids,
          query: this.searchForm.query,
          coach_name: this.searchForm.coach_name,
          sales_name: this.searchForm.sales_name,
          fee_package_id:
            this.searchForm.fee_package_id === -1
              ? null
              : this.searchForm.fee_package_id,
          coach_area: this.searchForm.coach_area,
          remark: this.searchForm.remark,
        };
      } else {
        return {
          company_ids: this.searchForm.company_ids,
          query: this.searchForm.query,
          coach_name: this.searchForm.coach_name,
          sales_name: this.searchForm.sales_name,
          fee_package_id:
            this.searchForm.fee_package_id === -1
              ? null
              : this.searchForm.fee_package_id,
          daterange_start: moment(this.searchForm.daterange[0]).format(
            "YYYY-MM-DD"
          ),
          daterange_end:
            moment(this.searchForm.daterange[1]).format("YYYY-MM-DD") +
            " 23:59:59",
          coach_area: this.searchForm.coach_area,
          remark: this.searchForm.remark,
        };
      }
    },
  },
  mounted() {
    this.fetchExamServiceList();
    this.fetchFeePackageList();
    this.fetchCompanyList();
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.table.doLayout();
    });
  },
  methods: {
    filterStatus(value, row) {
      return row.status === value;
    },
    filterPayStatus(value, row) {
      return row.pay_status === value;
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.status === "作废" || row.status === "退款") {
        return "row-red";
      } else {
        return "";
      }
    },
    fetchExamServiceList() {
      this.$http.get("/dbapi/sys_combo_list?name=培训服务").then((response) => {
        if (response.data.success) {
          this.examServiceList = response.data.list;
        }
      });
    },
    fetchFeePackageList() {
      this.$http.get("/dbapi/fee_package_list?status=启用").then((response) => {
        if (response.data.success) {
          this.feePackageList = response.data.list;
        }
      });
    },
    searchCoach: _.debounce(
      // 搜索教练
      function (query) {
        this.coachLoading = true;
        this.$http.get("/dbapi/coach_combo?query=" + query).then((response) => {
          this.coachLoading = false;
          if (response.data.success) {
            this.coachList = response.data.list;
          }
        });
      },
      500
    ),
    searchSecu: _.debounce(
      // 搜索安全员
      function (query) {
        this.secuLoading = true;
        this.$http
          .get(
            `/dbapi/secu_combo?company_id=${this.editForm.company_id}&query=${query}`
          )
          .then((response) => {
            this.secuLoading = false;
            if (response.data.success) {
              this.secuList = response.data.list;
            }
          });
      },
      500
    ),
    searchSales: _.debounce(
      // 搜索业务员
      function (query) {
        this.salesLoading = true;
        this.$http.get(`/dbapi/sales_combo?query=${query}`).then((response) => {
          this.salesLoading = false;
          if (response.data.success) {
            this.salesList = response.data.list;
          }
        });
      },
      500
    ),
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        const values = data.map((item) => Number(item[column.property]));
        if (this.sumProps.indexOf(column.property) >= 0) {
          let i = -1;
          sums[index] = values.reduce((prev, curr) => {
            i++;
            const value = Number(curr);
            if (!isNaN(value) && data[i].status === "正常") {
              if (data[i].fin_type === "0") {
                return prev - curr;
              } else {
                return prev + curr;
              }
            } else {
              return prev;
            }
          }, 0);
          // sums[index] = sums[index].toFixed(2)
        } else if (column.property === "company_name") {
          sums[index] = "合计";
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    fetchCompanyList() {
      // 获取考场列表
      this.$http.get("/dbapi/company_combo").then((response) => {
        if (response.data.success) {
          this.companyList = response.data.list;
          this.searchForm.company_ids = this.companyList.map((c) => c.value);
        }
      });
    },
    editInfo(row) {
      // 修改信息
      this.secuList = [
        {
          value: row.secu_id,
          label: row.secu_name,
        },
      ];
      this.coachList = [
        {
          value: row.coach_id,
          label: row.coach_name,
        },
      ];
      this.salesList = [
        {
          value: row.sales_id,
          label: row.sales_name,
        },
      ];
      this.editForm = {
        id: row.id,
        company_id: row.company_id,
        coach_id: row.coach_id,
        secu_id: row.secu_id,
        sales_id: row.sales_id,
        remark: row.remark,
        route_name: row.route_name,
        exam_service: row.exam_service,
        fee_package_id: row.fee_package_id,
      };
      if (row.fee_package_id > 0) {
        try {
          this.feePackageListEditFilter = this.feePackageList.filter(
            (r) =>
              r.fee ==
              this.feePackageList.filter((r) => r.id == row.fee_package_id)[0]
                .fee
          );
        } catch (e) {
          this.feePackageListEditFilter = [];
        }
      } else {
        this.feePackageListEditFilter = [];
      }
      this.editFormVisible = true;
    },
    editCommit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editCommiting = true;
          this.$http
            .post("/dbapi/edit_bill", this.editForm)
            .then((response) => {
              this.editCommiting = false;
              if (response.data.success) {
                this.editFormVisible = false;
                this.refresh();
              } else {
                this.$message({
                  type: "error",
                  message: response.data.message,
                });
              }
            });
        }
      });
    },
    rePay(row) {
      // 重新结算
      this.$http
        .post("/dbapi/bill_re_pay", {
          id: row.id,
        })
        .then((response) => {
          if (response.data.success) {
            this.refresh();
          } else {
            this.$message({
              type: "error",
              message: response.data.message,
            });
          }
        });
    },
    invalid(row) {
      // 作废单据
      this.$http
        .post("/dbapi/bill_invalid", {
          id: row.id,
        })
        .then((response) => {
          if (response.data.success) {
            this.refresh();
          } else {
            this.$message({
              type: "error",
              message: response.data.message,
            });
          }
        });
    },
    valid(row) {
      // 恢复单据
      this.$http
        .post("/dbapi/bill_valid", {
          id: row.id,
        })
        .then((response) => {
          if (response.data.success) {
            this.refresh();
          } else {
            this.$message({
              type: "error",
              message: response.data.message,
            });
          }
        });
    },
    showStudent(row) {
      // 显示学员窗口
      this.selectRow = row;
      this.studentDialogVisible = true;
      this.studentForm.bill_id = row.id;
      this.studentForm.company_id = row.company_id;
      this.fetchStudentList();
    },
    fetchStudentList() {
      // 读取学员列表
      this.studentLoading = true;
      this.$http
        .get("/dbapi/student_list?car_id=0&bill_id=" + this.studentForm.bill_id)
        .then((response) => {
          this.studentLoading = false;
          if (response.data.success) {
            this.studentList = response.data.list;
          } else {
            this.$message({
              type: "error",
              message: response.data.message,
            });
          }
        });
    },
    addStudent() {
      // 添加学员
      this.$refs.studentForm.validate((valid) => {
        if (valid) {
          this.studentAdding = true;
          this.$http
            .post("/dbapi/insert_student_bill", this.studentForm)
            .then((response) => {
              this.studentAdding = false;
              if (response.data.success) {
                this.fetchStudentList();
                this.$refs.studentForm.resetFields();
              } else {
                this.$message({
                  type: "error",
                  message: response.data.message,
                });
              }
            });
        }
      });
    },
    readIdcard() {
      // 读身份证
      this.studentAdding = true;
      this.$idcard
        .read()
        .then((data) => {
          return this.$http.post("/dbapi/insert_student_bill", {
            bill_id: this.studentForm.bill_id,
            company_id: this.studentForm.company_id,
            name: data.name,
            idcard: data.code,
          });
        })
        .then((response) => {
          this.studentAdding = false;
          if (response.data.success) {
            this.fetchStudentList();
          } else {
            this.$message({
              type: "error",
              message: response.data.message,
            });
          }
        })
        .catch(() => {
          this.studentAdding = false;
        });
    },
    delStudent(row) {
      this.$http
        .post("/dbapi/del_student_bill", {
          id: row.id,
        })
        .then((response) => {
          if (response.data.success) {
            this.fetchStudentList();
          }
        });
    },
    pay(id) {
      this.billId = id;
      this.payDialogVisible = true;
    },
    detail(id) {
      this.billId = id;
      this.billDialogVisible = true;
    },
    payConfirm() {
      this.payDialogVisible = false;
      this.refresh();
    },
    payCancel() {
      this.payDialogVisible = false;
    },
    printBill(row) {
      // if (row.pay_total == row.pay_coupon && this.user.group_id == 2) {
      //   window.open(this.$http.receiptBaseUrl + '/bill_print_coupon?id=' + row.id + '&token=' + localStorage.getItem('kaochang.token'))
      // } else {
      window.open(
        this.$http.receiptBaseUrl +
          "/bill_print?id=" +
          row.id +
          "&token=" +
          localStorage.getItem("kaochang.token")
      );
      // }
    },
    showTrack(id) {
      this.trackDialogVisible = false;
      this.trackDialogGpsData = [];
      this.$http.get("/api/gpsdata?t=bill&id=" + id).then((response) => {
        if (response.data.success) {
          let list = response.data.list;
          if (list.length === 0) {
            this.$alert(
              "这段时间内没有GPS数据，请检查车载GPS设备是否正常",
              "提示",
              {
                confirmButtonText: "我知道了",
              }
            );
          } else {
            for (var i = 0; i < list.length; i++) {
              list[i].lonlat = offset(
                parseFloat(list[i].lon),
                parseFloat(list[i].lat)
              );
            }
            this.trackDialogGpsData = list;
            this.trackDialogVisible = true;
          }
        } else {
          this.$alert(response.data.message, "提示", {
            confirmButtonText: "我知道了",
          });
        }
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/rent/Bills.vue